import { render, staticRenderFns } from "./VDataTableCompanies.vue?vue&type=template&id=0dff1890&scoped=true"
import script from "./VDataTableCompanies.vue?vue&type=script&lang=js"
export * from "./VDataTableCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dff1890",
  null
  
)

export default component.exports